<template>
  <div class="wrapper">
    <loader fill="white" v-if="isLoading" />
    <section v-else class="appeal">
      <div v-if="isTimeExpired" class="appeal-success">
        <h2 class="appeal-subtitle">{{ $t("helpForm.subTitleExpired") }}</h2>
      </div>
      <template v-else>
        <appeals-form
          :categories="categories"
          :exhibitions="exhibitions"
          :disabled="isError"
        />
      </template>
    </section>
  </div>
</template>

<script>
import { Loader } from "@v2/shared/ui/components";
import { defineComponent } from "vue";
import { AppealsForm } from "@v2/features/appeals";
import appealsApi from "@v2/entities/appeals/api";

export default defineComponent({
  components: { Loader, AppealsForm },
  data() {
    return {
      categories: [],
      exhibitions: [],
      isLoading: false,
      isError: false
    };
  },
  methods: {
    async loadCategories() {
      const response = await appealsApi.getCategories();
      this.categories = response.data;
    },
    async loadExhibitions() {
      const response = await appealsApi.getTodayExhibitions();
      this.exhibitions = response.data;
    }
  },
  async mounted() {
    this.isLoading = true;
    try {
      await Promise.all([this.loadExhibitions(), this.loadCategories()]);
    } catch (e) {
      this.isError = true;
      await this.$store.dispatch(
        "common/setErrorMessage",
        this.$t("helpForm.error")
      );
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    isTimeExpired() {
      return !this.exhibitions.length && !this.isLoading && !this.isError;
    }
  }
});
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
.wrapper {
  box-sizing: border-box;
  width: 100%;
  max-width: 800px;
  text-align: center;
}

.appeal {
  box-sizing: border-box;
  width: 100%;
  background: var(--white, #fff);
  max-width: 800px;
  text-align: center;
  padding: 30px 20px;
  margin: 30px 0;
  &-title {
    @include h1();
    @include respond-down(md) {
      font-size: 28px;
    }
  }
  &-subtitle {
    color: var(--dark-light, #6d7179);
    padding: 10px 0;
    font-weight: 400;
  }
  &-success {
    display: flex;
    flex-direction: column;
    & .primary-button {
      align-self: center;
    }
  }
}
</style>
